export default "__VITE_ASSET__BQ3anhmw__"